import { createStyles } from "@material-ui/core";
export default (function (theme) {
  return createStyles({
    paper: {
      backgroundColor: '#fff',
      border: '1px solid #e2e2e2',
      borderBottom: 0
    },
    tr: {},
    key: {
      wordBreak: 'break-word'
    },
    rowKey: {
      paddingLeft: theme.spacing(3),
      fontSize: 12
    },
    value: {
      wordBreak: 'break-word'
    },
    rowValue: {
      wordBreak: 'break-word',
      fontSize: 12
    },
    trSlim: {
      height: 24
    },
    tdSlim: {
      padding: '5px 8px 3.4px',
      lineHeight: 1.1
    },
    expandButtonSlim: {
      padding: 0
    }
  });
});